export const primaryColor = '#838280'
export const lineColor = '#8382800C'

const currentDate = new Date();
export const formatDateWithTime = currentDate.getDate() + '.' + ((currentDate.getMonth() < 9) ? '0' : '') + (currentDate.getMonth() + 1) + '.' + currentDate.getFullYear() + ' '
    + ((currentDate.getHours() < 9) ? '0' : '') + (currentDate.getHours()) + ':' + ((currentDate.getMinutes() < 9) ? '0' : '') + (currentDate.getMinutes());
export const formatDate = currentDate.getDate() + '.' + ((currentDate.getMonth() < 9) ? '0' : '') + (currentDate.getMonth() + 1) + '.' + currentDate.getFullYear()
